import PropTypes from "prop-types";
import React, {Component} from "react";
import Typography from "@material-ui/core/Typography/Typography";


// constants
const DEFAULT_FONT_SIZE = 19;


// class definition
export class Text extends Component {

    static propTypes = {
        children: PropTypes.string.isRequired,
        style: PropTypes.any,
        bold: PropTypes.bool,
        oblique: PropTypes.bool,
        uppercase: PropTypes.bool
    };

    static defaultProps = {
        style: [],
        bold: false,
        oblique: false,
        uppercase: false
    };

    render() {

        // resolve properties
        let text = this.props.children;
        const {style, bold, oblique, uppercase} = this.props;

        // normalize style to look for size
        const mergedStyles = style;
        const fontSize = mergedStyles.fontSize || DEFAULT_FONT_SIZE;
        const styles = {
            fontFamily: bold ? "TradeGothicLTBold" : "TradeGothicLTStd",
            fontSize,
            fontWeight: "normal",
            fontStyle: oblique ? "oblique" : "normal"
        };

        // apply uppercase (if required)
        if (uppercase && text) {
            text = text.toLocaleUpperCase();
        }

        if (text && text.split("\n").length > 1) {
            text = text ? text.split("\n").map((item, key) => { return <span key={key}>{item}<br/></span> }) : text;
        }

        // render view
        return (
            <Typography
                style={{...styles, ...mergedStyles}}>{text}</Typography>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Text.js